import { REHYDRATE } from 'redux-persist';
import {
  DATA_IMPORT_FETCH,
  DATA_IMPORT_UPLOAD,
} from '../actions';

const INIT_STATE = {
  list: [],
  list_paging: { total_rows: 0, page_size: 25, page_indx: 0 },
  uploading: false,
};

const handler = (state = INIT_STATE, action) => {
  switch (action.type) {
    case DATA_IMPORT_FETCH.REQUEST: {
      const page = action.payload?.page
      const page_size = action.payload?.page_size
      return {
        ...state,
        list: [],
        list_paging: {
          ...state.list_paging,
          ...(page !== undefined ? { page_indx: page } : {}),
          ...(page_size !== undefined ? { page_size } : {}),
        },
      }
    }
    case DATA_IMPORT_FETCH.SUCCESS: {
      const { rows, total_rows, page_size, page_indx } = action.payload
      return { ...state, list: rows, list_paging: { total_rows, page_size, page_indx } }
    }
    case DATA_IMPORT_UPLOAD.REQUEST:
      return { ...state, uploading: true }
    case DATA_IMPORT_UPLOAD.SUCCESS:
    case DATA_IMPORT_UPLOAD.ERROR:
      return { ...state, uploading: false }
    case REHYDRATE:
      return INIT_STATE
    default:
      return state
  }
}

export default handler
